module.exports = __webpack_public_path__ + "static/media/400171_02.dfe08899.png";